import { useEffect } from 'react';

export default function useProtection() {
  useEffect(() => {
    // Disable text selection
    const noSelect = (e) => e.preventDefault();
    document.addEventListener('selectstart', noSelect);

    // Disable copy/cut
    const noCopy = (e) => e.preventDefault();
    document.addEventListener('copy', noCopy);
    document.addEventListener('cut', noCopy);

    // Disable drag
    const noDrag = (e) => e.preventDefault();
    document.addEventListener('dragstart', noDrag);

    // Block keyboard shortcuts (keep Ctrl+A, Ctrl+S, F12, Ctrl+U, DevTools)
    const noKeys = (e) => {
      if (e.key === 'F12' || e.keyCode === 123) { e.preventDefault(); return false; }
      if (e.ctrlKey && ['u','U'].includes(e.key)) { e.preventDefault(); return false; }
      if (e.ctrlKey && e.shiftKey && ['I','i','J','j','C','c'].includes(e.key)) { e.preventDefault(); return false; }
      if (e.ctrlKey && ['s','S'].includes(e.key)) { e.preventDefault(); return false; }
    };
    document.addEventListener('keydown', noKeys);

    // CSS protection - no text selection, no image drag
    const style = document.createElement('style');
    style.id = 'plux-protection';
    style.textContent = `
      * { -webkit-user-select: none !important; -moz-user-select: none !important; user-select: none !important; }
      img { pointer-events: none !important; -webkit-user-drag: none !important; }
    `;
    document.head.appendChild(style);

    // DevTools detection
    const devToolsCheck = setInterval(() => {
      const threshold = 160;
      if (window.outerWidth - window.innerWidth > threshold || window.outerHeight - window.innerHeight > threshold) {
        clearInterval(devToolsCheck);
        document.body.innerHTML = `
          <div style="display:flex;align-items:center;justify-content:center;height:100vh;background:#0a0a0a;color:#fff;font-family:sans-serif;text-align:center;">
            <div><div style="font-size:64px">🔒</div><h2>Accès non autorisé</h2></div>
          </div>`;
      }
    }, 1000);

    return () => {
      document.removeEventListener('selectstart', noSelect);
      document.removeEventListener('copy', noCopy);
      document.removeEventListener('cut', noCopy);
      document.removeEventListener('dragstart', noDrag);
      document.removeEventListener('keydown', noKeys);
      clearInterval(devToolsCheck);
      const s = document.getElementById('plux-protection');
      if (s) s.remove();
    };
  }, []);
}
